import { FC } from 'react';

import { ImageWrapper } from 'src/__generated__/graphqlTypes';
import { WebpImage } from 'components/Shared/SharedComponents';

import styles from './DynamicModalWithStore.module.scss';

import type { ChildProps } from '../config/declarations';

export const HeadingSection: FC<ChildProps> = ({
  block,
}) => {
  if (!block) {
    return null;
  }

  const { main, badge } = block.imagesCollection?.items?.reduce((acc, item) => {
    if (item?.slug === 'main') {
      acc.main = item;
    }

    if (item?.slug === 'badge' || !item?.slug) {
      acc.badge = item!;
    }

    return acc;
  }, {} as Record<string, ImageWrapper>) || {} as Record<string, ImageWrapper>;

  if (!main?.image?.url) {
    return null;
  }

  const badgeImage = badge?.image;

  return (
    <div className={styles.header}>
      <WebpImage
        image={main.image}
        disableDefaultSource
        className={styles.main}
      />
      {badgeImage && (
        <WebpImage
          image="external"
          src={badgeImage?.url || ''}
          disableDefaultSource
          className={styles.badge}
        />
      )}
    </div>
  );
};
